import get from 'lodash/get';
import { isQueryAlertLanding } from './utils';

const trovitSelector = state => state.trovit;

export const querySelector = state => get(trovitSelector(state), 'query');

export const queryAlertLandingSelector = state =>
  Number(get(trovitSelector(state), ['trovit', 'query', 'alertLanding']));

export const isQueryAlertLandingSelector = state =>
  isQueryAlertLanding(Number(get(trovitSelector(state), ['query', 'alertLanding'])));

export const queryDsaTgSelector = state => get(trovitSelector(state), ['query', 'dsa', 'tg']);

export const queryOriginSelector = state => get(trovitSelector(state), ['query', 'origin']);



// WEBPACK FOOTER //
// ./app/request/query/selectors.js